import React, { createContext, useState, ReactChild, useContext } from 'react';

import * as interfaces from 'interfaces';
import { UserService } from 'services';

export const UserContext = createContext({
  user: {} as interfaces.UserInterface,
  updateUser: (user: interfaces.UserInterface): void => { },
  userIsSet: false,
  isSignedIn: false,
  setIsSignedIn: (v: boolean): void => { },
  isVisitor: false,
  setIsVisitor: (v: boolean): void => { }
});

const userService = new UserService()

export const UserContextProvider = (props: { children: ReactChild | ReactChild[] }) => {
  var user: interfaces.UserInterface = userService.getLocalUserData();

  const [userIsSet, registerUser] = useState(false);
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [isVisitor, setIsVisitor] = useState(false);

  const setUser = () => {
    if (!userIsSet && user?.id) registerUser(true)
  }

  const updateUser = (u: interfaces.UserInterface) => {
    // Work around the propagated state issue
    // if (
    //   (user?.id && Object.values(user).join(',') === Object.values(u).join(',')) ||
    //   Object.keys(u).length === 0
    // ) return

    user = u
    userService.defaultUser = u
    userService.storeLocalUserData(u)

    setUser()
  }

  return (
    <UserContext.Provider value={{ user, updateUser, userIsSet, isSignedIn, setIsSignedIn, isVisitor, setIsVisitor }}>
      <>{props.children}</>
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);
